import { createStore } from '@stencil/store';

const store = createStore({
  isMainCommentFormOpen: true,
  activeComments: [] as string[],
  apiUrl: '',
  apiKey: '',
  getCommentsApiUrl: '',
  setCommentApiUrl: '',
  deleteCommentApiUrl: '',
  deactivateCommentApiUrl: '',
  emailInfoText: '',
  netiquetteLink: '',
  stayInformedText: '',
  successMessage: '',
  commentsPerPage: 3,
  isEditMode: false,
  offset: 0,
  i18n: {} as any,
});

// eslint-disable-next-line import/no-default-export
export default store;
